import { useEffect, useState } from "react";
import {
  Autocomplete,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  List,
  TextField,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Edit, Delete, BrowseGallery, HolidayVillage } from "@mui/icons-material";
import ApiCalls from "services/flick_erp_api_call";
import MDButton from "components/MDButton";
import colors from "assets/theme/base/colors";
import moment from "moment";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CustomDay } from "./customDay";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { useTheme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";

function Holidays({ permissions, modulePermissions }) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [eventsData, setEventsData] = useState({});
  const [employeeBranch, setEmployeeBranch] = useState(null);
  const [branch, setBranch] = useState([]);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [holidayDialogOpen, setHolidayDialogOpen] = useState(false);
  const [openHolidayData, setOpenHolidayData] = useState(false);
  const [postHolidayPayload, setPostHolidayPayload] = useState({});
  const [typeError, setTypeError] = useState("");
  const [holidayNameError, setHolidayNameError] = useState("");
  const [dateError, setDateError] = useState("");
  const [holidays, setHolidays] = useState();

const typeList = [
  { name: "National", type: "n" },
  { name: "State", type: "s" },
  { name: "Optional", type: "o" },
  ];

  useEffect(() => {
    getEmployee();
  },[]);
  

  useEffect(() => {
    if (employeeBranch) {
      getHolidays();
    }
  }, [employeeBranch]);

  const getHolidayStatus = (date) => {
    const today = moment().startOf("day");
    const eventDate = moment(date).startOf("day");
    if (eventDate.isBefore(today)) return "past";
    if (eventDate.isSame(today, "day")) return "current";
    return "future";
  };

  async function getBranch() {
    var res = await ApiCalls.getBranch();
    if (res.success && res.code == 200) {
      setBranch(res.data);
    } else {
    }
  }


  const getSoftBg = (color) => {
    return `${color}22`;
  };

  const holidayStyles = {
    past: {
      opacity: 0.3,
    },

    current: {
      border: "1px solid #328ced",
    },

    future: {
      opacity: 0.7,
    },
  };

  const ui = {
		text : darkMode ? "white" : "black",
    surface: darkMode ? palette.background.card : "#fafafa",
    soft: darkMode ? palette.background.muted : colors.background.elevated,
    border: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.14),
    title: darkMode ? palette.text.focus : colors.dark.main,
    body: darkMode ? palette.text.main : colors.secondary.main,
    calendar: darkMode
      ? `linear-gradient(180deg, ${palette.background.card} 0%, ${palette.background.muted} 100%)`
      : `linear-gradient(180deg, ${colors.light.main} 0%, ${colors.background.accent} 100%)`,
  };

  async function getEmployee() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user != undefined || user != null) {
      var res = await ApiCalls.getEmployee(user.employee_id);

      if (res.success && res.code == 200) {
        setEmployeeBranch(Number(res.data.branch));
      } else {
      }
    }
  }

  const handleDeleteClick = (id) => {
    deleteHoliday(id);
  };
  const handleEditClick = (data) => {
    setPostHolidayPayload({
      id: data.id,
      date: data.date,
      name: data.name,
      type: data.type,
      branch: Array.isArray(data.branch) ? data.branch : [Number(data.branch)],
      request: "edit",
    });
    setCreateDialogOpen(true);
  };

  async function getHolidays() {
    const res = await ApiCalls.getholidaysList(2026);

    if (res.success && res.code === 200) {
      const data = res.data;

      const branchHolidays = data.filter((h) => {
        if (!employeeBranch) return false;
        return Array.isArray(h.branch) && h.branch.includes(employeeBranch);
      });

      setHolidays(branchHolidays);

      const holidayEvents = {};
      branchHolidays.forEach((h) => {
        const dateKey = moment(h.date).format("YYYY-MM-DD");

        if (!holidayEvents[dateKey]) {
          holidayEvents[dateKey] = [];
        }

        holidayEvents[dateKey].push({
          id: h.id,
          title: h.name,
          date: h.date,
          type: h.type,
          time: "",
          color:
            h.type === "n"
              ? "#F48AA7"
              : h.type === "s"
                ? "#F7D532"
                : "#A9D6E5",
        });
      });

      setEventsData(holidayEvents);
    }
  }

  async function deleteHoliday(id) {
    const res = await ApiCalls.deleteHoliday(id);

    if (res.success && res.code === 204) {
      getHolidays();
    } else {
    }
  }
  async function createHoliday() {
    let hasError = false;
    let error = "This field may not be blank.";

    if (
      postHolidayPayload.name === undefined ||
      postHolidayPayload.name === ""
    ) {
      setHolidayNameError(error);
      hasError = true;
    } else {
      setHolidayNameError("");
    }
    if (
      postHolidayPayload.date === undefined ||
      postHolidayPayload.date === ""
    ) {
      setDateError(error);
      hasError = true;
    } else {
      setDateError("");
    }
    if (
      postHolidayPayload.type === undefined ||
      postHolidayPayload.type === ""
    ) {
      setTypeError(error);
      hasError = true;
    } else {
      setTypeError("");
    }

    if (!hasError) {
      const res = await ApiCalls.createHolidays(
        {
          date: postHolidayPayload.date,
          name: postHolidayPayload.name,
          type: postHolidayPayload.type,
          branch: postHolidayPayload.branch || [],
        },
        false
      );
      if (res.success && res.code === 201) {
        setPostHolidayPayload({});
        setCreateDialogOpen(false);
        getHolidays();
      } else if (res.success == false && res.code == 400) {
        const errors = res.data;
        if (errors.name) {
          alert(errors.name[0]);
        } else if (errors.date) {
          alert(errors.date[0]);
        } else if (errors.type) {
          alert(errors.type[0]);
        }
      } else {
      }
    }
  }
  async function updateHoliday(id) {
    const res = await ApiCalls.updateHoliday(
      id,
      {
        org: JSON.parse(localStorage.getItem("user")).org_id,
        date: postHolidayPayload.date,
        name: postHolidayPayload.name,
        type: postHolidayPayload.type,
        branch: postHolidayPayload.branch || [],
      },
      false
    );
    if (res.success && res.code === 200) {
      setPostHolidayPayload({});
      setCreateDialogOpen(false);
      getHolidays();
    } else {
    }
  }
  const handleCreateSubmit = () => {
    createHoliday();
  };
  const handleEditSubmit = (id) => {
    updateHoliday(id);
  };
  const handleSubmit = (id) => {
    if (postHolidayPayload.request == "create") {
      handleCreateSubmit();
    } else {
      handleEditSubmit(postHolidayPayload.id);
    }
  };

  const sortedEvents = Object.entries(eventsData)
    .sort(([dateA], [dateB]) => moment(dateA).diff(moment(dateB)))
    .flatMap(([date, eventList]) =>
      eventList.map((event) => ({ date, ...event }))
    );

  return (
    <DashboardLayout>
      <DashboardNavbar/>
      <Card
        sx={{
          backgroundColor: ui.surface,
          marginTop: "20px",
          border: `1px solid ${ui.border}`,
          boxShadow: darkMode ? "0 20px 44px rgba(2, 6, 23, 0.28)" : undefined,
        }}
      >
      <MDBox p={3}>
        <MDBox>
            <MDBox sx={{display: "flex" ,gap : 2, padding: 2}} >
							<MDBox
								sx={{
									width: 48,
									height: 48,
									borderRadius: "16px",
									display: "grid",
									placeItems: "center",
									background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
									color: colors.white.main,
								}}
							>
								<HolidayVillage />
							</MDBox>
							<MDBox>
            <MDTypography variant="h4" fontWeight={700} gutterBottom sx={{fontSize:{xs:"20px"}}}> 
              Holiday Calendar
            </MDTypography>
            <MDTypography variant="body2" sx={{ color: ui.body }}>
              Plan your leaves and view upcoming company holidays.
            </MDTypography>
						</MDBox>
          </MDBox>
        </MDBox>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MDBox
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr",
              },
              // height: "100vh",
              gap: 4,
              p: { xs: 1, md: 2 },
            }}
          >
            <MDBox
              sx={{
                // p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                overflow: "hidden",
              }}
            >
              <DateCalendar
                value={selectedDate}
                onChange={(newValue) => setSelectedDate(newValue)}
                views={["day"]}
                slots={{ day: CustomDay }}
                slotProps={{ day: { eventsData } }}
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", sm: "420px" },
                  height: { xs: "auto", sm: "460px" },
                  background: ui.calendar,
                  border: `1px solid ${ui.border}`,
                  borderRadius: "24px",

                  "& .MuiDayCalendar-root": {
                    minHeight: "380px",
                  },
                  "& .MuiPickersSlideTransition-root": {
                    overflow: "hidden",
                  },

                  "& .MuiPickersDay-root": {
                    width: { xs: 32, sm: 38 },
                    height: { xs: 32, sm: 38 },
                    fontSize: { xs: "0.7rem", sm: "0.85rem" },
                    color : darkMode ? palette.text.focus : "#504848",
                    borderRadius: "50%",
                  },
                  "& .Mui-selected": {
                    backgroundColor: `${darkMode ? rgba(colors.info.main, 0.22) : "#EDEDED"} !important`,
                    color: `${darkMode ? palette.text.focus : "#504848"} !important`,
                  },
                  "& .MuiPickersCalendarHeader-label": {
                    fontSize: "1.1rem",
                    fontWeight: 600,
                  },
                  "& .MuiPickersCalendarHeader-root": {
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                  },
                  "& .MuiPickersCalendarHeader-labelContainer": {
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                  },
                  "& .MuiPickersArrowSwitcher-root": {
                    width: "100%",
                    maxWidth: "280px",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0 auto",
                  },

                }}
              />

              <MDBox
                sx={{
                  display: "flex",
                  justifyContent:"center",
                  gap:{xs:1,md:2},
                  mt: 4,
                  width: "100%"
                }}
              >
                  <MDBox sx={{ width: 16, height: 16, bgcolor: "#EDEDED", borderRadius: "3px" }} />
                  <MDTypography variant="caption" sx={{ color: ui.body }}>Today</MDTypography>

                  <MDBox sx={{ width: 16, height: 16, bgcolor: "#F48AA7", borderRadius: "3px" }} />
                  <MDTypography variant="caption" sx={{ color: ui.body }}>National Holiday</MDTypography>

                  <MDBox sx={{ width: 16, height: 16, bgcolor: "#F7D532", borderRadius: "3px" }} />
                  <MDTypography variant="caption" sx={{ color: ui.body }}>Festivals</MDTypography>

                  <MDBox sx={{ width: 16, height: 16, bgcolor: "#A9D6E5", borderRadius: "3px" }} />
                  <MDTypography variant="caption" sx={{ color: ui.body }}>Optional</MDTypography>
              </MDBox>
            </MDBox>

            <MDBox>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 3,
                }}
              >
                <MDTypography variant="h6" fontWeight={600}>
                  Holidays - 2026
                </MDTypography>

                <MDBox
                  sx={{
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: 500,
                  }}
                >

                  <MDBox
                    lineHeight={1}
                    sx={{
                      display: "flex",
                      justifyContent: "end",

                      borderRadius: 3,
                    }}
                  >
                    {permissions?.includes(modulePermissions?.create_permission) ? (
                      <Grid item>
                        <MDButton
                          //color="white"
                          onClick={() => {
                            setCreateDialogOpen(true);
                            // setAddClicked(true);
                            setPostHolidayPayload({ request: "create", branch: [] });
                            getBranch();
                          }}
                          sx={{
                            border: `1px solid ${ui.border}`,
                            ml: 4,
														backgroundColor: colors.info.main, color: "White",
                            "&:hover": { color : colors.white.main },
                          }}
                        >
                          Add Holiday
                        </MDButton>
                      </Grid>
                    ) :
                      <MDTypography variant="h6">
                        {Object.values(eventsData).flat().length} Days
                      </MDTypography>
                    }
                  </MDBox>
                </MDBox>
              </MDBox>

              <List
                sx={{
                  maxHeight: "275px",
                  overflowY: "auto",
                }}>
                {sortedEvents.length > 0 ? (
                  // sortedEvents.map(([date, eventList]) =>
                  sortedEvents.map((event, idx) => {
                    const status = getHolidayStatus(event.date);
                    return (
                      <MDBox
                        key={event.date + idx}
                        sx={{
                          mb: 2,
                          px: 2,
                          borderRadius: "14px",
                          transition: "0.3s",
                          backgroundColor: getSoftBg(event.color),
                          border: `1px solid ${event.color}`,
                          ...holidayStyles[status],

                        }}
                      >
                        <MDBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: "0 !important",
                          }}
                        >
                          {/* Left section */}
                          <MDBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            {/* Date badge */}
                            <MDBox
                              sx={{
                                width: 38,
                                height: 38,
                                backgroundColor: event.color,
                                color: colors.white.main,
                                display: "flex",
                                gap: 0,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                paddingBottom: "6px",
                                fontWeight: 600,
                              }}
                            >
                              <MDTypography variant="body2" fontSize="12px" sx={{ p: 0 }}>
                                {moment(event.date).format("MMM")}
                              </MDTypography>
                              <MDTypography variant="body2" fontSize="12px" sx={{ lineHeight: 0.5, p: 0 }}>
                                {moment(event.date).format("D")}
                              </MDTypography>
                            </MDBox>

                            {/* Title */}
                            <MDBox>
                              <MDTypography variant="h6">{event.title}</MDTypography>
                              <MDTypography variant="body2" sx={{ m: 0, color: ui.body }}>
                                {moment(event.date).format("dddd")}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                          {/* Right section */}
                          {(permissions?.includes(modulePermissions?.update_permission) ||
                            permissions?.includes(modulePermissions?.delete_permission)) && (
                              <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                {/* {permissions?.includes(modulePermissions?.delete_permission) && ( */}
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      handleDeleteClick(event.id);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                                {/* )} */}
                                {/* {permissions?.includes(modulePermissions?.update_permission) && ( */}
                                <Tooltip title="Edit">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      handleEditClick({
                                        id: event.id,
                                        date: event.date,
                                        name: event.title,
                                        type: event.type,
                                        branch: holidays.find(h => h.id === event.id)?.branch || [],
                                      })

                                    }}
                                  >
                                    <Edit />
                                  </IconButton>
                                </Tooltip>
                                {/* )} */}
                              </div>
                            )}
                        </MDBox>
                      </MDBox>
                    )
                  })
                  // )
                ) : (
                  <MDTypography>No Holidays!</MDTypography>
                )}
              </List>
            </MDBox>
          </MDBox>
        </LocalizationProvider>
				<MDBox sx={{ mt: 4, display: "flex", alignItems: "center",justifyContent: "center", gap: 1 }}>
					      <MDBox sx={{ width: 16, height: 16, bgcolor: colors.info.main, borderRadius: "3px" }} />
								<MDTypography variant="h6" fontWeight={600}>Important:</MDTypography>
								<MDTypography variant="body2" fontWeight={400}>
									Employees are allowed to select only one optional holiday from the provided list during the calendar year.
								</MDTypography>
							</MDBox>
      </MDBox>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.surface,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            width: { xs: "90%", sm: "500px", md: "600px" },
            height: "auto",
            maxWidth: "100%",
            borderRadius: "20px",
            cursor: "pointer",
            border: `1px solid ${ui.border}`,
            backgroundImage: "none",
          },
        }}
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
      >
          <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <MDTypography sx={{ color: "White", fontWeight: "Medium" }}>
              Add Holiday
            </MDTypography>
            <Icon
              fontSize="medium"
              onClick={() => {
                setCreateDialogOpen(false);
                setPostHolidayPayload({});
              }}
							color="White"
            >
              close
            </Icon>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
          }}
        >
          <Card
            id="basic-info"
            sx={{
              overflow: "visible",
              background: ui.calendar,
              border: `1px solid ${ui.border}`,
            }}
          >
            <MDBox component="form" pb={3} px={3} pt={3}>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Holiday Name"
                    variant="standard"
                    value={postHolidayPayload.name}
                    onChange={(event) => {
                      setPostHolidayPayload((state) => ({
                        ...state,
                        name: event.target.value,
                      }));
                      setHolidayNameError("");
                    }}
                    required
                    error={!!holidayNameError}
                    helperText={holidayNameError}
                  ></TextField>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    InputProps={{}}
                    id="date"
                    type="date"
                    value={postHolidayPayload.date}
                    name="date"
                    onChange={(event) => {
                      setPostHolidayPayload((state) => ({
                        ...state,
                        date: event.target.value,
                      }));
                      setDateError("");
                    }}
                    required
                    error={!!dateError}
                    helperText={dateError}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Autocomplete
                    id="Type"
                    options={typeList}
                    value={
                      typeList.filter(
                        (e) => e.type == postHolidayPayload.type
                      )[0]
                    }
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        name="Type"
                        label="Select Type"
                        variant="standard"
                        required
                        error={!!typeError}
                        helperText={typeError}
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setPostHolidayPayload((state) => ({
                          ...state,
                          type: newValue.type,
                        }));
                      }
                      setTypeError("");
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Autocomplete
                    multiple
                    id="branch"
                    options={branch}
                    value={branch?.filter((b) =>
                      postHolidayPayload.branch?.includes(b.id)
                    )}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Branch"
                        variant="standard"
                        required
                      />
                    )}
                    onChange={(event, newValue) => {
                      setPostHolidayPayload((state) => ({
                        ...state,
                        branch: newValue.map((item) => item.id),
                      }));
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                fullWidth
                pt={3}
                // md={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <MDButton
                  variant="gradient"
                  color="dark"
                  onClick={() => handleSubmit()}
                >
                  Submit
                </MDButton>
              </Grid>
            </MDBox>
          </Card>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.surface,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            width: "600px",
            height: "auto",
            maxWidth: "none",
            borderRadius: "20px",
            cursor: "pointer",
            border: `1px solid ${ui.border}`,
          },
        }}
        open={holidayDialogOpen}
        onClose={() => setHolidayDialogOpen(false)}
      >
          <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <MDTypography sx={{ color: "white", paddingRight: "60px", fontWeight: "Medium" }}>
              {openHolidayData?.name}
            </MDTypography>
            <MDTypography sx={{ color: "white", paddingRight: "30px", fontWeight: "Medium" }}>
              {moment(openHolidayData.date).format("ddd") + "/" + moment(openHolidayData.date).format("MMM") + "/" + moment(openHolidayData.date).year()}
            </MDTypography>
            <Icon
              fontSize="medium"
              onClick={() => {
                setHolidayDialogOpen(false);
                setOpenHolidayData({});
              }}
            >
              close
            </Icon>
          </div>
        </DialogTitle>
      </Dialog>
      
			 </Card>
    </DashboardLayout>
  );
}
export default Holidays;
